<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "History",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "History",
      items: [
        {
          text: "History",
          href: "/history",
        },
        {
          text: "Index",
          active: true,
        },
      ],
      activities: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      sortBy: "createdAt",
      sortDesc: true,
      fields: [
        { key: "user", label: "User", sortable: false },
        { key: "message", label: "Action", sortable: false },
        { key: "time", label: "Date & Time", sortable: false }
      ]
    };
  },
  methods: {
    fetchData(ctx, callback) {
      this.apiGet(`/activities`, { include: 'createdBy', limit: 20, page: ctx.currentPage }).then((data) => {
        this.totalRows = data.meta.cursor.count;
        callback(data.data);
      }).catch((error) => {
        this.$store.dispatch('layout/addPageError', error);
        callback([]);
      })

      return null;
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive mb-0">
              <b-table
                :items="fetchData"
                :fields="fields"
                responsive="sm"
                class="mb-0"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
              >
                <template v-slot:cell(user)="row">
                  <div class="d-flex align-items-center">
                    <img
                      :src="row.item.createdBy.profileImage ? row.item.createdBy.profileImage.url : require('@/assets/images/placeholder-user.png')"
                      class="mr-3 rounded-circle avatar-xs"
                      alt="user-pic"
                    />
                    <h4 class="card-title mb-0">{{ row.item.createdBy.firstName }} {{ row.item.createdBy.lastName }}</h4>
                  </div>
                </template>
                <template v-slot:cell(time)="row">
                  {{ row.item.createdAt | formatDate('DD/MM/YYYY hh:mm a') }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>